<template>
  <div class="TGA">
    <div class="bg">
      <img style="width: 100%; height: 100%" src="@/img/bg.jpg" alt="" />
    </div>
    <a-layout id="layout" style="min-height: 100%">
      <div class="header_box">
        <a-layout-header class="header">
          <!-- <div class="logo" /> -->

          <router-link tag="div" class="TGA_title CU" to="/index"
            ><img class="TGA_title_img" :src="$t('layout.logo')" alt=""
          /></router-link>

          <div class="router_nav" style="height: 65px">
            <div
              class="router_text CU noneselect"
              :class="selectedkeys == item.meta.state ? 'text_active' : ''"
              v-for="(item, index) in menus"
            >
              <div
                class="router"
                v-if="index != 4"
                @click="clickrouter(item.path)"
              >
                <span class="nav-text">{{
                  $t("router." + [item.meta.title])
                }}</span>
              </div>
              <div class="router" v-if="index == 4" @click="handleMenuClick">
                <span class="nav-text">{{
                  $t("router." + [item.meta.title])
                }}</span>
              </div>
              <!--    <a-dropdown v-model="visible"  class='router-dropdown-link' v-if="index == 4">
                 <a class="ant-dropdown-link " @click="e => e.preventDefault()" >
                 {{$t('router.'+[item.meta.title])}}
                 </a>
                 <a-menu slot="overlay" style='margin-top: 20px;' @click="handleMenuClick">
                   <a-menu-item key="1" >
                      APP接入
                   </a-menu-item>
                    <a-menu-item key="1" >
                      流量方接入
                    </a-menu-item>
                 </a-menu>
               </a-dropdown> -->
            </div>
          </div>
          <!-- 这个是登录注册 -->
          <navuser class="navuser"></navuser>
        </a-layout-header>
      </div>
      <!-- 'background-image': `url(${require('@/img/background.png')})`, -->
      <a-layout-content>
        <div>
          <router-view
            :style="{
              position: 'relative',
              'z-index': '2',
              'padding-top': '65px',
            }"
          ></router-view>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center"
        ><footers style="width: 100%; height: 100%"></footers
      ></a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import footers from "@/views/footer";
import navuser from "@/views/nav_user";
import { BASE_HOST } from "../config/config";

export default {
  components: {
    footers,
    navuser,
  },
  data() {
    return {
      accountType: 0,
      visible: false,
      selectedkeys: [this.$route.meta.state],
    };
  },

  mounted() {
    // console.log('77777',this.$route.meta.state)
  },

  methods: {
    ...mapActions("user", ["tipMessage"]),

    handleMenuClick(e) {
      window.open(`${BASE_HOST}/tga-doc${this.$t("config.h5tgadoc")}`);
    },

    clickrouter(path) {
      console.log("dianji la a ");
      var configlink = [
        "/login",
        "/info",
        "/register",
        "/agreement",
        "/forget",
        "/type",
      ];
      if (path == "/file") {
        return;
      }
      if (path == "/index" || path == "/contact") {
      } else {
        if (!localStorage.getItem("mp_accessToken")) {
          this.$message.info(this.$t("layout.select_login"));
          this.$router.push({
            path: "/login",
          });
          return;
        }
        if (configlink.includes(this.$route.path)) {
          this.$message.info(this.$t("layout.select_info"));
          this.$router.push({
            path: "/info",
          });
          return;
        }
      }
      if (this.$route.path == path) {
        return;
      }
      this.$router.push({
        path: path,
      });
    },
  },

  watch: {
    $route(to, from) {
      this.accountType = localStorage.getItem("roleName")
        ? localStorage.getItem("roleName")
        : 0;
      return (this.selectedkeys = [to.meta.state]);
    },
  },
  computed: {
    menus() {
      console.log("切换了页面了啊222222");
      this.accountType = localStorage.getItem("roleName")
        ? localStorage.getItem("roleName")
        : "GAME_DEVELOPER";
      let obj = this.$router.options.routes[0].children[0].children;
      let arr = [];
      obj.forEach((item, index) => {
        if (this.accountType.includes("GAME_DEVELOPER")) {
          if (index != 2) {
            arr.push(item);
          }
        } else {
          if (index != 1) {
            arr.push(item);
          }
        }
      });

      return arr;
    },
  },
};
</script>

<style scoped="scoped">
.TGA {
  width: 100%;
  /* height: 100%; */
  /* overflow: hidden; */
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.router_nav {
  /* width: 50%; */
  margin-left: 2%;
}
.router_text {
  height: 63px;
  display: flex;
  align-items: center;
  color: #222222;
  float: left;
}
.router {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.text_active {
  box-sizing: border-box;
  color: #4990fa;
  border-bottom: 2px solid #4990fa;
}
.router_text:hover {
  color: #4990fa;
}
.router_text:hover .router-dropdown-link {
  color: #4990fa;
}
.TGA .ant-layout {
  background-color: rgba(255, 255, 255, 0);
  height: 100%;
}
#layout {
  min-height: 100vh;
  position: relative;
  z-index: 10;
}
.ant-layout-header {
  /* background-color: #373d41; */
  background-color: #ffffff;
  height: 65px;
  line-height: 0;
  display: flex;
  align-items: center;
}
.header {
  width: 100%;
  display: flex;
  margin: 0 auto;
  padding: 0 5% 0 3%;
  position: relative;
  /* padding:  0 170px 0 200px; */
  justify-content: space-between;
}
.header_router {
  margin-left: 6.8%;
  /* position: absolute; */
}
#layout .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 28px 16px 0;
  float: left;
}
.ant-menu-horizontal {
  background-color: #373d41;
  border-bottom: none;
}

.ant-layout .ant-layout-has-sider {
  min-height: 100%;
}

.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom: 2px solid #ffffff;
}
/* .nav-text {
  color: #222222;
}
.text_active .nav-text {
  color: #4990fa;
} */

.ant-layout-content {
  /* min-height: 100vh; */
  min-height: calc(100vh - 180px);
  padding: 0;
  background-image: url("~@/img/background.png");
}

.TGA_title {
  color: #ffffff;
  font-size: 28px;
}

.ant-layout-footer {
  background-color: #373d41;
  padding: 0;
  height: 180px;
}
.TGA_title_img {
  width: 208px;
  height: 20px;
}

.bg {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.navuser {
  /* position: absolute; */
  /* right: 10.54%; */
  right: 150px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
.header_box {
  z-index: 100;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 70px;
  /* background-color: #373d41; */
  background-color: #ffffff;
  border-bottom: solid 1px #dbe9fe;
}

/* @media screen and (max-width: 1680px) {
  body,
  html {
    overflow: auto;
  }
  .TGA {
    width: 1680px;
  }

  .header {
    padding: 0 60px 0 80px;
    width: 1680px;
  }
  .navuser {
    right: 150px;
  }
} */

@media screen and (max-width: 1440px) {
  body,
  html {
    overflow: auto;
  }
  .TGA {
    width: 1440px;
  }
  .router_nav {
    /* margin-left: 50px; */
  }
  .header {
    /* padding: 0 40px 0 50px; */
    width: 1440px;
  }
  .navuser {
    /* right: 50px; */
  }
}

/* @media screen and (max-width:1200px){
    .router_nav{
       margin-left: 10px;
    }
    .header{
      width: 1440px;
      background-color: #373d41;
      padding:  0 10px 0 20px;
    }
    .navuser{

      right: 20px;
    }
   } */

a {
  color: #999999;
}

.noneselect {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue